import React, { Component } from 'react';
import BarChart from "react-apexcharts";
export class PollQuestion extends Component {

  render() {
    const { question, index, data, votesCount } = this.props;
    const chart = {

      options: {
        tooltip: {
          enabled: true,
          x: { show: false },
          y: [{
            show: false,
            title: {
              formatter: (questionName, data) => {
                const index = data.dataPointIndex;
                return question.answers[index];
              }
            },
          }],
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: data.every(num => num !== 0),
          formatter: function (val) {
            return val;
          },
          offsetY: -30,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },
        xaxis: {
          categories: question.answers,
          position: 'bottom',
          labels: {
            offsetY: 0,
          },
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: true
          },
        },
        fill: {
          gradient: {
            shade: 'light',
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [50, 0, 100, 100]
          },
        },
        yaxis: {
          labels: {
            show: true,
            formatter: (val) => +val.toFixed(1)
          }
        },
      },
      series: [{
        name: question.name,
        data: data
      }]

    }

    return (
      <div style={{maxWidth: '600px', margin: 'auto'}}>
        <h5>
          Question {index + 1}: {question.name}
        </h5>
        <BarChart options={chart.options} series={chart.series} type="bar" height="250" />
        {/* <div>
          {(question.answers || []).map((answer, answerIndex) => {
            const percentage = votesCount ? (data[answerIndex] / votesCount * 100).toFixed(2) : 0;

            return (
              <div key={answer} style={{display: 'flex', justifyContent: 'space-between'}}>
                <div>{answerIndex + 1}. {answer}</div>
                <div style={{minWidth: '140px', display: 'flex', justifyContent: 'space-between'}}>
                  <div>Votes: {data[answerIndex]}</div>
                  <div>-</div>
                  <div style={{minWidth: '40px', textAlign: 'end'}}>{percentage}%</div>
                </div>
              </div>
            )
          })}
        </div> */}
      </div>

    );
  }
};
